import { render } from "./PageArtober2023_P1.vue?vue&type=template&id=3497d405&scoped=true"
import script from "./PageArtober2023_P1.vue?vue&type=script&lang=js"
export * from "./PageArtober2023_P1.vue?vue&type=script&lang=js"

import "./PageArtober2023_P1.vue?vue&type=style&index=0&id=3497d405&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3497d405"]])

export default __exports__